import { useEffect, useState } from "react";
import { MemberLayout } from "../../components/Layouts";
import { api, readUser, errMsg } from "../../lib/api";

export default function Wallet() {
  const [user, setUser] = useState(readUser());
  const [form, setForm] = useState({ wallet_address: "", password: "" });
  const [notice, setNotice] = useState({ ok: false, msg: "" });

  useEffect(() => {
    api.get("/auth/me").then((r) => { setUser(r.data); setForm((f) => ({ ...f, wallet_address: r.data.wallet_address || "" })); localStorage.setItem("ha_user", JSON.stringify(r.data)); });
  }, []);

  async function save(e) {
    e.preventDefault();
    setNotice({ ok: false, msg: "" });
    try {
      await api.put("/profile/wallet", form);
      setNotice({ ok: true, msg: "Wallet address updated." });
      setForm({ ...form, password: "" });
    } catch (e) { setNotice({ ok: false, msg: errMsg(e) }); }
  }

  return (
    <MemberLayout user={user} active="Wallet">
      <div className="deposit-grid">
        <div className="panel">
          <div className="panel-heading"><div><span className="eyebrow">WITHDRAWAL WALLET</span><h3>Where your USDT is sent</h3></div></div>
          <form onSubmit={save} className="deposit-form">
            <label>BEP20 wallet address<input data-testid="wallet-address" value={form.wallet_address} onChange={(e) => setForm({ ...form, wallet_address: e.target.value })} required /></label>
            <label>Confirm with your password<input data-testid="wallet-password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required /></label>
            {notice.msg && <div className={notice.ok ? "success" : "error"} data-testid="wallet-notice">{notice.msg}</div>}
            <button className="btn btn-accent full" data-testid="wallet-save">Save wallet</button>
          </form>
          <p className="note">For your protection, every wallet change is confirmed with your current password.</p>
        </div>
        <div className="panel activity">
          <div className="panel-heading"><div><span className="eyebrow">YOUR DEPOSIT REFERENCE</span><h3>Attach to every deposit</h3></div></div>
          <div className="referral-code">
            <div><span>REFERENCE</span><strong data-testid="wallet-reference">{user?.deposit_reference || "—"}</strong></div>
          </div>
          <p className="note">Your reference uniquely identifies you to the operations team when a deposit needs review.</p>
        </div>
      </div>
    </MemberLayout>
  );
}
